import { ReducerMap } from 'app/RouteDefinition';

export const reducers: ReducerMap = {};